import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { withStyles } from '@material-ui/core/styles'
import {
  MODAL_ADMIN_EDIT_PRODUCT,
  MODAL_ADMIN_CREATE_PRODUCT,
  MODAL_ADMIN_DELETE_PRODUCT,
  MODAL_ADMIN_REORDER_PRODUCT
} from 'redux/modules/modals'
const transformCategory = cat => cat.name
const transformTaxe = taxe => Number(taxe.tax_value) * 100
const columnDataAll = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Nom' },
  {
    id: 'price',
    numeric: true,
    float: 2,
    disablePadding: false,
    label: 'Prix (€)'
  },
  {
    id: 'category',
    numeric: false,
    disablePadding: true,
    label: 'Catégorie',
    transform: transformCategory
  },
  { id: 'color', numeric: false, disablePadding: false, label: 'Couleur' },
  {
    id: 'tva',
    numeric: true,
    disablePadding: false,
    label: 'TVA (%)',
    transform: transformTaxe
  }
]
const columnDataCat = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Nom' },
  {
    id: 'price',
    numeric: true,
    float: 2,
    disablePadding: false,
    label: 'Prix (€)'
  },
  {
    id: 'category',
    numeric: false,
    disablePadding: true,
    label: 'Catégorie',
    transform: transformCategory
  },
  { id: 'color', numeric: false, disablePadding: false, label: 'Couleur' },
  {
    id: 'tva',
    numeric: true,
    disablePadding: false,
    label: 'TVA (%)',
    transform: transformTaxe
  },
  {
    id: 'order',
    numeric: true,
    disablePadding: false,
    label: "Ordre d'affichage"
  }
]
const styles = theme => ({
  rootTabs: {
    flexGrow: 1,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    height: 51
  },
  rootTab: {
    height: 51
  }
})
export default withStyles(styles)(
  class AdminProductsComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      categories: PropTypes.array.isRequired,
      products: PropTypes.array.isRequired,
      showModal: PropTypes.func.isRequired
    }
    state = {
      tabValue: 0,
      currentCategory: void 0
    }
    handleCreateProductClick = () => {
      this.props.showModal(
        MODAL_ADMIN_CREATE_PRODUCT,
        this.state.currentCategory
      )
    }
    handleEditProductClick = product => {
      this.props.showModal(MODAL_ADMIN_EDIT_PRODUCT, product)
    }
    handleDeleteClick = product => {
      this.props.showModal(MODAL_ADMIN_DELETE_PRODUCT, product)
    }
    handleReorderClick = () => {
      this.props.showModal(
        MODAL_ADMIN_REORDER_PRODUCT,
        this.props.products.filter(
          p => p.category.key === this.state.currentCategory.key
        )
      )
    }
    handleChange = (event, value) => {
      this.setState({
        tabValue: value,
        currentCategory: value === 0 ? void 0 : this.props.categories[value - 1]
      })
    }
    render() {
      const { classes, products, categories } = this.props
      const { tabValue, currentCategory } = this.state
      if (categories.length === 0) return null
      const currentProducts =
        tabValue === 0
          ? products
          : products.filter(p => p.category.key === currentCategory.key)
      return (
        <section className="pageAdmin">
          <Tabs
            className={classes.rootTabs}
            value={tabValue}
            onChange={this.handleChange}
            scrollable
            scrollButtons="auto"
            indicatorColor="secondary">
            <Tab className={classes.rootTab} label="Tous les produits" />
            {categories.map((cat, index) => {
              return (
                <Tab
                  className={classes.rootTab}
                  key={cat.key}
                  label={cat.name}
                />
              )
            })}
          </Tabs>
          <AdminTableComponent
            title="Produits"
            list={currentProducts}
            selectable
            orderBy={tabValue === 0 ? 'category' : 'order'}
            columnData={tabValue === 0 ? columnDataAll : columnDataCat}
            addButtonAction={this.handleCreateProductClick}
            editButtonAction={this.handleEditProductClick}
            reOrderAction={
              tabValue === 0 || currentProducts.length < 2
                ? null
                : this.handleReorderClick
            }
            deleteButtonAction={this.handleDeleteClick}
          />
        </section>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Admin/Products/components/AdminProductsComponent.js